var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/"}},[_c('i',{staticClass:"fas fa-key"}),_vm._v(" "+_vm._s(_vm.keywords_count)+" "+_vm._s(_vm.$t('global.keywords'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }